import { Dispose } from "./disposable";
import { VoidCallback } from "./signatures";

export class ChangeNotifier extends Dispose {
  constructor() {
    super();
    this.appendDisposeCallback(() => {
      this._listeners = [];
    });
  }
  private _listeners: VoidCallback[] = [];

  readonly addListener = (listener: VoidCallback) => {
    this._listeners.push(listener);
    return () => {
      this.removeListener(listener);
    };
  };

  readonly removeListener = (listener: VoidCallback) => {
    this._listeners = this._listeners.filter((l) => l !== listener);
  };

  readonly notifyListeners = () => {
    this._listeners.forEach((v) => v());
  };
}
